<section class="customer-stories">
  <div class="conatiner-fluid">
    <div class="breadcrumb-wrapper">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="container">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container pt-5 pb-5">
    <h1 class="fw-semibold cv-text-dark" >{{isForDealer ?  'Dealer Stories' :'Customer Stories' }}</h1>
    <div class="content-heading mb-4 d-flex align-items-center">
            <nav class="ms-auto bg-light-gray">
        <div class="nav nav-pills thinscrollforname" id="pills-tab" role="tablist">
          <button class="nav-link active" id="pills-video-testimonial-tab" data-bs-toggle="tab"
            data-bs-target="#pills-video-testimonial" type="button" role="tab" aria-controls="nav-video-testimonial"
            aria-selected="true" (click)="changeTestimonial('VIDEO',false)">Video Testimonials</button>
          <button class="nav-link" id="pills-testimonials-tab" data-bs-toggle="tab" data-bs-target="#pills-testimonials"
            type="button" role="tab" aria-controls="pills-testimonials" aria-selected="false"
            (click)="changeTestimonial('TEXT',false)">Testimonials</button>
            <button   class="nav-link" id="pills-dealer-testimonials-tab" data-bs-toggle="tab" data-bs-target="#pills-dealer-testimonials"
            type="button" role="tab" aria-controls="pills-dealer-testimonials" aria-selected="false"
            (click)="changeTestimonial('DEALER', true); ">Dealer Testimonials</button>

        </div>
      </nav>
    </div>
    <div class="tab-content" id="pills-tabContent" *ngIf="!isForDealer">
      <div class="tab-pane fade show active" id="pills-video-testimonial" role="tabpanel" *ngIf="storyType == 'VIDEO'"
        aria-labelledby="pills-video-testimonial-tab">
        <div class="row g-4">
          <ng-container *ngIf="customerStories?.length == 0 && storyType == 'VIDEO' && !productLoaded; else loadingContent">
            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4" *ngFor="let item of skeletonService.generateFake(3);let i = index;">
              <div class="card border-0 custStory h-100">
                <div class="card-img-top ">
                  <ngx-skeleton ></ngx-skeleton>
                </div>
                <div class="card-body pt-4 pb-4">
                  <ngx-skeleton height="40px"></ngx-skeleton>
                </div>
              </div>
            </div>
        </ng-container>

        <ng-template #loadingContent>
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 cursor" *ngFor="let item of customerStories" data-bs-toggle="modal"
           data-bs-target="#fetchOn_price1"  (click)="vedioModal(item.yt_url, false)">
            <div class="card border-0 custStory h-100">
              <div class="card-img-top  hideImg">
                <img  src="{{item?.image_url}}" alt="{{item?.name}}" class="img-fluid" loading="lazy">
              </div>
              <div class="ratio  ratio-16x9 hideVideo" style="width: 100%; height: 234px;">
                <iframe safeUrl [src]="item?.yt_url" frameborder="0" allowfullscreen></iframe>
              <!-- <ngx-lite-youtube [videoId]="item?.yt_url"></ngx-lite-youtube> -->
              </div>
              <div class="card-img-overlay hideImg">
                <a href="javascript:void(0);" class="play-icon">
                  <img [src]="environment1 + 'images/new-images/play.svg'" alt="play" loading="lazy">
                </a>

                <div class="quote">
                  <img [src]="environment1 + 'images/new-images/blueline.svg'" alt="blueline" loading="lazy">
                </div>
              </div>

              <div class="card-body pt-4">
                  <h5 class="fw-bold mb-0">{{item?.description}}</h5>
                <p class="mb-0">{{item?.ppl}}</p>
              </div>
              <div class="card-img-overlay hideImg">
                <a href="#" class="play-icon">
                  <img [src]="environment1 + 'images/new-images/play.svg'" alt="play" loading="lazy">
                </a>
                <div class="quote">
                  <img [src]="environment1 + 'images/new-images/blueline.svg'" alt="blueline" loading="lazy">
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        </div>
      </div>
      <div class="modal modal-fetch-price fetchOn_price" id="fetchOn_price1" data-bs-keyboard="false" tabindex="-1" aria-labelledby="fetchOn_priceLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
          <div class="modal-content model-contentformobile border-0">
            <div class="modal-body">
              <button type="button" class="btn-close close-button" data-bs-dismiss="modal" aria-label="Close" (click)="closeVideoModal()"></button>
              <div class="col-12 col-sm-12">
                <div class="card border-0 custStory h-100">
                  <div class="ratio ratio-16x9">
                    <iframe *ngIf="videoUrl" [src]="videoUrl" frameborder="0" allowfullscreen></iframe>
                <!-- <ngx-lite-youtube  [videoId]="videoUrl"></ngx-lite-youtube> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane fade show active testimonial-tab" id="pills-testimonials" role="tabpanel" *ngIf="storyType == 'TEXT'"
        aria-labelledby="pills-testimonials-tab">
        <div class="row g-4">
          <ng-container *ngIf="customerStories?.length == 0 && storyType == 'TEXT' && !productLoaded; else loadingContent1">
            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4" *ngFor="let item of skeletonService.generateFake(3);let i = index;">
              <div class="card border-0 custStory h-100">
                <div class="card-img-top ">
                  <ngx-skeleton ></ngx-skeleton>
                </div>
                <div class="card-body pt-4 pb-4">
                  <ngx-skeleton height="40px"></ngx-skeleton>
                </div>
              </div>
            </div>
        </ng-container>

        <ng-template #loadingContent1>
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4" *ngFor="let item of customerStories" data-bs-toggle="modal" data-bs-target="#fetchOn_price2"
           (click)="vedioModal(item.yt_url,false)" style="cursor: pointer;">
           <div class="card border-0 custReadStory h-100">
              <div class="card-body hideImg" style="width: 100%; height: 290px;">
                <p class="desc">{{item?.description}}</p>
                <div class="customer-details d-flex align-items-center">
                  <div class="user-img">
                <img src="{{item?.image_url}}" class="img-fluid" loading="lazy">
                    <!-- <img [src]='environment1 + "assets/images/user-icon.png"' class="img-fluid" alt="cutomer" loading="lazy"> -->
                  </div>
                  <div class="content ms-3">
                    <h6 class="fw-bold mb-0">{{item?.name ? item?.name : "-"}}</h6>
                    <p class="mb-0">{{item?.model ? item?.model: "-"}}</p>
                  </div>
                </div>
              </div>
              <div class="ratio  ratio-16x9 hideVideo">
                <iframe safeUrl [src]="item?.yt_url" frameborder="0" allowfullscreen></iframe>
                <!-- <ngx-lite-youtube [videoId]="item?.yt_url"></ngx-lite-youtube> -->
              </div>
            </div>
          </div>
        </ng-template>

        </div>
      </div>

    </div>





<!-- // dealer Testimonials -->
    <div class="tab-content" id="pills-tabContent" *ngIf="isForDealer" >
      <div class="tab-pane fade show active" id="pills-dealer-testimonials" role="tabpanel"
      aria-labelledby="pills-dealer-testimonials-tab" *ngIf="storyType == 'DEALER'">
      <div class="row g-4">
        <ng-container *ngIf="customerStories?.length == 0 && storyType == 'DEALER' && !productLoaded; else loadingContent2">
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4" *ngFor="let item of skeletonService.generateFake(3);let i = index;">
            <div class="card border-0 custStory h-100">
              <div class="card-img-top ">
                <ngx-skeleton ></ngx-skeleton>
              </div>
              <div class="card-body pt-4 pb-4">
                <ngx-skeleton height="40px"></ngx-skeleton>
              </div>
            </div>
          </div>
      </ng-container>

      <ng-template #loadingContent2>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 cursor" *ngFor="let item of customerStories" data-bs-toggle="modal"
         data-bs-target="#fetchOn_price"  (click)="vedioModal(item.yt_url,false)">
          <div class="card border-0 custStory h-100">
            <div class="card-img-top  hideImg">
              <img  src="{{item?.image_url}}" alt="{{item?.name}}" class="img-fluid" loading="lazy">
            </div>
            <div class="ratio  ratio-16x9 hideVideo" style="width: 100%; height: 234px;">
              <iframe safeUrl [src]="item?.yt_url" frameborder="0" allowfullscreen></iframe>
            <!-- <ngx-lite-youtube [videoId]="item?.yt_url"></ngx-lite-youtube> -->
            </div>
            <div class="card-img-overlay hideImg">
              <a href="javascript:void(0);" class="play-icon">
                <img [src]="environment1 + 'images/new-images/play.svg'" alt="play" loading="lazy">
              </a>

              <div class="quote">
                <img [src]="environment1 + 'images/new-images/blueline.svg'" alt="blueline" loading="lazy">
              </div>
            </div>

            <div class="card-body pt-4">
                <h5 class="fw-bold mb-0">{{item?.name}}</h5>
              <p class="mb-0">{{item?.designation}}</p>
            </div>
            <div class="card-img-overlay hideImg">
              <a href="#" class="play-icon">
                <img [src]="environment1 + 'images/new-images/play.svg'" alt="play" loading="lazy">
              </a>
              <div class="quote">
                <img [src]="environment1 + 'images/new-images/blueline.svg'" alt="blueline" loading="lazy">
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      </div>
    </div>
    <div class="modal modal-fetch-price fetchOn_price" id="fetchOn_price" data-bs-keyboard="false" tabindex="-1" aria-labelledby="fetchOn_priceLabel1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content model-contentformobile border-0">
          <div class="modal-body">
            <button type="button" class="btn-close close-button" data-bs-dismiss="modal" aria-label="Close" (click)="closeVideoModal()"></button>
            <div class="col-12 col-sm-12">
              <div class="card border-0 custStory h-100">
                <div class="ratio ratio-16x9">
                  <iframe *ngIf="videoUrl" [src]="videoUrl" frameborder="0" allowfullscreen></iframe>
              <!-- <ngx-lite-youtube *ngIf="videoUrl"  [videoId]="videoUrl"></ngx-lite-youtube> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>


  <div  class="modal modal-fetch-price fetchOn_price" id="fetchOn_price" data-bs-keyboard="false" tabindex="-1" aria-labelledby="fetchOn_priceLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
      <div class="modal-content  model-contentformobile  border-0">
        <div class="modal-body">
          <button type="button" class="btn-close close-button" data-bs-dismiss="modal" aria-label="Close" (click)="closeVideoModal()"></button>
          <div class="col-12 col-sm-12">
            <div class="card border-0 custStory h-100">
              <div class="ratio ratio-16x9">
                <!-- <ngx-lite-youtube *ngIf="videoUrl" [videoId]="getURL(videoUrl)"></ngx-lite-youtube> -->
                <iframe *ngIf="videoUrl" [src]="videoUrl" frameborder="0" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 empty-states"
  *ngIf="(errormsg == 'Data not found.' && isForDealer) || (customerStories?.length == 0  && !isForDealer)">
  <img [src]='environment1 + "assets/images/no_wishlist_found.svg"' loading="lazy">
  <h3 *ngIf="errormsg == 'Data not found.' && isForDealer">
    Dealer Testimonial is Empty
  </h3>
  <h3 *ngIf=" customerStories?.length == 0  && !isForDealer ">
    Video Testimonial is Empty
  </h3>
</div>
</section>




